// import { io } from "socket.io-client";
// import api from '../api/axios';
// import config from "../config";
// let socket = null;

// export const connectSocket = async () => {
//   if (socket) {
//     console.warn("⚠️ Socket already connected.");
//     return socket;
//   }

//   socket = io(config.SOCKET_BASE_URL, {
//     transports: ["websocket"],
//     autoConnect: false,
//     withCredentials: true, // 👈 This sends the accessToken cookie
//   });

//   // 👇 Listen for events
//   socket.on("connect", () => {
//     console.log("🔌 Socket connected:");
//   });

//   socket.on("disconnect", (reason) => {
//     console.log("👋 Socket disconnected:", reason);
//   });

//   socket.on("connect_error", async (err) => {
//     console.error("❌ Socket connect error:", err.message);

//     // 👇 Check if the error was due to an expired token
//     if (err.message === "Authentication error") {
//       try {
//         console.log("🔁 Attempting to refresh token...");

//         await api.post(`/cauthRoutes/customer/refresh-token`); // backend uses cookies to send new token

//         console.log("✅ Token refreshed. Retrying socket connection...");

//         socket.disconnect();
//         socket = null;
//         await new Promise((res) => setTimeout(res, 300));
//         // Retry socket connection
//         connectSocket();

//       } catch (refreshErr) {
//         console.error("🚫 Token refresh failed:", refreshErr.message);
//         // Optionally: trigger logout or redirect
//       }
//     }
//   });
 
//   socket.connect();
//   return socket;
// };

// export const disconnectSocket = () => {
//   if (socket) {
//     socket.disconnect();
//     socket = null;
//     console.log("🔌 Socket manually disconnected");
//   }
// };

// export const getSocket = () => socket;
import { io } from "socket.io-client";
import api from "../api/axios";
import config from "../config";

let socket = null;
let isConnecting = false;

export const connectSocket = async () => {
  if (socket && socket.connected) {
    return socket;
  }

  if (isConnecting) {
    return socket;
  }

  isConnecting = true;

  socket = io(config.SOCKET_BASE_URL, {
    transports: ["websocket"],
    withCredentials: true,
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });

  /* ================= CORE LISTENERS (ONCE) ================= */

  socket.once("connect", () => {
    console.log("🔌 Socket connected:", socket.id);
    isConnecting = false;
  });

  socket.once("disconnect", (reason) => {
    console.log("👋 Socket disconnected:", reason);
  });

  socket.on("connect_error", async (err) => {
    console.error("❌ Socket connect error:", err.message);

    if (err.message === "Authentication error") {
      try {
        await api.post("/cauthRoutes/customer/refresh-token");

        console.log("🔁 Token refreshed. Reconnecting socket...");
        socket.connect();
      } catch (refreshErr) {
        console.error("🚫 Token refresh failed:", refreshErr.message);
        disconnectSocket();
      }
    }
  });

  socket.connect();
  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
    isConnecting = false;
    console.log("🔌 Socket fully cleaned up");
  }
};
